import { extract } from '@app/core';
import { FormTemplateComponent } from '@app/shared/form/form-template.component';
var ɵ0 = {
    title: extract('Form templates'),
};
var routes = [
    {
        path: 'form-template',
        component: FormTemplateComponent,
        data: ɵ0,
    },
];
var FormModule = /** @class */ (function () {
    function FormModule() {
    }
    return FormModule;
}());
export { FormModule };
export { ɵ0 };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/form/form.module.ts.pre-build-optimizer.js